import React, { useEffect, useState } from "react";
import { ListaApeladasPendientes } from "../../components/Calificaciones/ListaApeladasPendientes";
import {
  PlaceholderColumnas,
  PlaceholderTabla,
} from "../../components/Otros/Placeholder";
import { InformacionProcesoCorto } from "../../components/ProcesosDeCalificacion/InformacionProcesoCorto";
import { cargarProcesoActivo } from "../../utils/Datos";

export const FirmarApelacion = () => {
  const [procesoActivo, setProcesoActivo] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);

  useEffect(() => {
    setCargandoDatos(true);
    cargarProcesoActivo().then((datos) => {
      setCargandoDatos(false);
      setProcesoActivo(datos);
    });
  }, []);

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <div className="toolbar" id="kt_toolbar">
        <div
          id="kt_toolbar_container"
          className="container-fluid d-flex flex-stack"
        >
          <div
            data-kt-swapper="true"
            data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
          >
            <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
              APELACIONES PENDIENTES DE FIRMA{" "}
            </h1>
            <span className="h-20px border-gray-300 border-start mx-4" />
            <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <li className="breadcrumb-item text-muted">
                <a href="#" className="text-muted text-hover-primary">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-300 w-5px h-2px" />
              </li>
              <li className="breadcrumb-item text-dark">
                {" "}
                 INFORMACIÓN DEL PROCESO
              </li>
            </ul>
          </div>
          <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
        </div>
      </div>
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bolder text-dark">
                       INFORMACIÓN DELPROCESO
                    </span>
                  </h3>
                </div>
                <div className="card-body">
                {cargandoDatos || procesoActivo == null ? (
                  <PlaceholderColumnas
                    columnas={3}
                    filas={1}
                  ></PlaceholderColumnas>
                ) : (
                  <InformacionProcesoCorto
                    proceso={procesoActivo}
                  ></InformacionProcesoCorto>
                )}
                </div>
                
              </div>
            </div>
            <div className="col-xl-12 ">
              <div className="card ">
                <div className="card-header ">
                  <h3 className="card-title align-items-start flex-column ">
                    <span className="card-label fw-bolder text-dark ">
                      CALIFICACIONES APELADAS PENDIENTES DE FIRMA
                    </span>
                  </h3>
                </div>
                <div className="card-body">
                  {procesoActivo != null ? (
                    <div className="table-responsive">
                      <ListaApeladasPendientes
                        idProcess={procesoActivo.id_process}
                      ></ListaApeladasPendientes>
                    </div>
                  ) : (
                    <PlaceholderTabla></PlaceholderTabla>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
